import React from 'react';
import {Route, Link} from 'react-router-dom';
import {Breadcrumb, BreadcrumbItem} from 'reactstrap';
import routes from '../../routes';
import store from 'store';

const findRouteName = url => routes[url];

const getPaths = (pathname) => {
	const paths = [];
	const routePaths = [];
  let url = '';

	for (let path of pathname.split('/')){
		if (path.length) paths.push('/' + path);
	}

	for (let path of paths) {
		url += path;
		const pathFromRoutes = findRouteName(url);
		if (pathFromRoutes) routePaths.push(url);
	}
	routePaths.unshift('/');
	
	return routePaths;
};

const BreadcrumbsItem = ({match}) => {
  const routeName = findRouteName(match.url);
  if (routeName) {
    return (
      match.isExact ?
        (
          <BreadcrumbItem active>{routeName}</BreadcrumbItem>
        ) :
        (
          <BreadcrumbItem><Link to={match.url || ''}>{routeName}</Link></BreadcrumbItem>
        )
      
    );
  }
  return null;
};

const Breadcrumbs = ({location : {pathname}, match}) => {
  const paths = getPaths(pathname);
//   const paths = ['/', pathname];
  const items = paths.map((path, i) => <Route key={i++} path={path} component={BreadcrumbsItem}/>);
  return (
    <Breadcrumb>
      {items}
      {/* <p className="float-right mb-0"><li className="breadcrumb-item" style={{'color':'#536c79'}}>Active View: <b id="modelNameBreadcrumb">{store.get('modelName')}</b></li></p> */}
    </Breadcrumb>
  );
};

export default props => (
  <div>
    <Route path="/:path" component={Breadcrumbs} {...props} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js